/**
 * Database type.
 */
export type DatabaseType =
    "mysql"|
    "postgres"|
    "mariadb"|
    "sqlite"|
    "cordova"|
    "sqljs"|
    "oracle"|
    "mssql"|
    "websql"|
    "mongodb";
